import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ChatWidget } from "../package/dist/index.es.js";
import "./index.css";
import { AxelLogo } from "./AxelLogo.jsx";
import "../package/dist/index.css";

const DEFAULT_STRICT_MODE = true;

const ensureContainer = (container) => {
  if (!container) {
    throw new Error("Axel: container is required");
  }

  const target =
    typeof container === "string"
      ? document.querySelector(container)
      : container;

  if (!target) {
    throw new Error(`Axel: container '${container}' not found`);
  }

  return target;
};

const renderWidget = (container, props, strictMode) => {
  const root = createRoot(container);

  const element = React.createElement(ChatWidget, props);
  const tree = strictMode
    ? React.createElement(StrictMode, null, element)
    : element;

  root.render(tree);

  return () => root.unmount();
};

const Axel = {
  init({ container, props, strictMode = DEFAULT_STRICT_MODE }) {
    const target = ensureContainer(container);

    const brandedProps = {
      ...props,
      options: {
        ...props.options,
        branding: {
          name: "Axel",
          strings: {
            header: "Ask Axel",
            inputPlaceholder: "Ask away...",
            triggerTooltip: "Need help? Ask Axel!",
          },
          beta: false,
          theme: "axel",
          icons: {
            trigger: {
              icon: (
                <div className="wgt-axel-trigger">
                  <AxelLogo />
                </div>
              ),
            },
            newChat: {
              icon: "New chat",
            },
            session: {
              icon: (
                <div className="wgt-axel-session">
                  <AxelLogo />
                </div>
              ),
            },
            close: {
              className: "wgt-axel-trigger",
            },
            bot: {
              icon: (
                <div className="wgt-axel-bot">
                  <AxelLogo />
                </div>
              ),
            },
          },
          predefinedPrompt: {
            title: "Hi Axel, what can you help me with?",
            prompt:
              "Hi Axel, can you let me know what you can do to help me and the functions you have available?",
          },
        },
        legal: {
          customTerms: [
            "Axel is provided by Auto Grab Pty Ltd (“AutoGrab”). Axel provides responses to help you with your car buying needs by using AI technology.",
            "Responses from Axel do not represent the views of CommBank or Vyro.",
          ],
          privacyPolicyUrl:
            "https://www.carsforcommbank.com.au/axel-ai-privacy-policy",
          termsUrl: "https://www.carsforcommbank.com.au/axel-ai-terms-of-use",
        },
        page: {
          size: {
            height: "100dvh",
          },
        },
      },
    };


    const unmount = renderWidget(target, brandedProps, strictMode);

    return { unmount };
  },
};

if (typeof window !== "undefined") {
  window.Axel = Axel;

  if (typeof window.AxelWrapper === "function") {
    try {
      window.AxelWrapper(Axel);
    } catch (error) {
      console.error("Error occurred while initializing AxelWrapper:", error);
    }
  }
}

export { Axel, ChatWidget };
export default Axel;
